import { render, staticRenderFns } from "./special-book-list.vue?vue&type=template&id=063aa5cd&scoped=true"
import script from "./special-book-list.vue?vue&type=script&lang=js"
export * from "./special-book-list.vue?vue&type=script&lang=js"
import style0 from "./special-book-list.vue?vue&type=style&index=0&id=063aa5cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063aa5cd",
  null
  
)

export default component.exports